import React, {useEffect} from 'react';

import {useEvent} from '../../data/hooks/eventHooks';
import Screen from './Screen';
import TopBar from '../elements/TopBar/TopBar';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import {useParams} from 'react-router';

export default function PleaseWait(props) {
    const {eventId} = useParams(),
        event = useEvent(eventId);

    useEffect(() => {
        document.body.classList.add('pleaseWait');
        return () => {
            document.body.classList.remove('pleaseWait');
        };
    });

    const header = event ? <TopBarEvent event={event}></TopBarEvent> : <TopBar></TopBar>;
    return <Screen header={header}></Screen>;
}
